import type { GuideIntegration, GuideNavigate } from './guides.models';

/** Guides hand over configured links verbatim; same-origin targets use the app router. */
export function routeGuideLink(url: string, navigate: GuideNavigate) {
  const target = new URL(url, globalThis.location.href);
  if (target.origin !== globalThis.location.origin) {
    globalThis.location.assign(target.href);
    return;
  }
  navigate(`${target.pathname}${target.search}${target.hash}`);
}

/** Generic SDK wiring; feature modules own their callback names and behavior. */
export function registerGuides({ navigate, callbacks }: GuideIntegration) {
  globalThis.engagement?.setRouter((url) => routeGuideLink(url, navigate));
  for (const { name, callback } of callbacks) {
    globalThis.engagement?.addCallback(name, callback);
  }
}
